"use strict";

const NET_STATS_SETTING_KEY = "showNetStat";

type HookSettingEntry = Krunker.Settings["list"][string] & {
  __hookNetStatsSetting?: boolean;
};

function coerceBool(value: unknown): boolean {
  return value === true || value === "true" || value === 1 || value === "1";
}

function setNetStatsEnabled(value: unknown): void {
  const enabled = coerceBool(value);
  const ioClient = window.io;
  if (ioClient) {
    ioClient.trackPacketStats = enabled;
    ioClient.resetPacketTally?.();
  }
  window.updatePacketLoop?.(enabled);

  const display = enabled ? "block" : "none";
  const ingressDisplay = document.getElementById("ingressDisplay");
  const egressDisplay = document.getElementById("egressDisplay");
  if (ingressDisplay) ingressDisplay.style.display = display;
  if (egressDisplay) egressDisplay.style.display = display;
}

function installNetStatsSetting(): boolean {
  const settings = window.settings;
  if (!settings?.list) return false;

  const existing = settings.list[NET_STATS_SETTING_KEY] as
    | HookSettingEntry
    | undefined;
  if (existing?.__hookNetStatsSetting) return true;

  const visibleSetting: HookSettingEntry = {
    key: NET_STATS_SETTING_KEY,
    name: existing?.name || "settings.interface.net-stats",
    cat: existing?.cat || "interface",
    val: coerceBool(existing?.val),
    def: coerceBool(existing?.def),
    type: existing?.type || "switch",
    set: setNetStatsEnabled,
    __hookNetStatsSetting: true,
  };

  settings.list[NET_STATS_SETTING_KEY] = visibleSetting;
  setNetStatsEnabled(visibleSetting.val);
  return true;
}

function scheduleNetStatsSettingInstall(): void {
  if (installNetStatsSetting()) return;
  window.requestAnimationFrame(scheduleNetStatsSettingInstall);
}

scheduleNetStatsSettingInstall();